import { DotCMSLanguageItem } from 'dotcms/src/lib/models';

export class CustomDotCmsPageHelper {
  static getCurrentLocale(language: DotCMSLanguageItem) {
    return `${language.languageCode}_${language.countryCode}`;
  }
}
